/* istanbul ignore file */
import styled, { css } from 'styled-components';
import { Icon as IconComponent } from 'src/components';
import _MissionCard from '../LearnImmerseCommunicate/Communicate/MissionCard';

export const Icon = styled(IconComponent)(
  ({ theme }) => css`
    position: absolute;
    bottom: -${theme.sz.s2};
    transform: rotate(-90deg);

    svg {
      width: ${theme.sz.s20};
      height: ${theme.sz.s20};
    }
  `,
);

export const Container = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-top: ${theme.sz.s24};
  `,
);

export const Title = styled.div(
  ({ theme }) => css`
    text-align: center;
    color: ${theme.co.primary99};
    font-family: ${theme.DEPRECATED_ty.boing};
    font-weight: ${theme.DEPRECATED_ty.bold};
    font-size: ${theme.sz.s10};
    line-height: 125%;
  `,
);

export const Description = styled.div(
  ({ theme }) => css`
    width: 60%;
    text-align: center;
    color: ${theme.co.primary99};
    font-size: ${theme.DEPRECATED_ty.large};
    line-height: 125%;
    margin-bottom: ${theme.sz.s12};
  `,
);

export const SubTitle = styled.div(
  ({ theme }) => css`
    text-align: center;
    color: ${theme.co.primary20};
    padding-top: ${theme.sz.s4};
    font-size: ${theme.DEPRECATED_ty.large};
    font-weight: ${theme.DEPRECATED_ty.bold};
  `,
);

export const CTA = styled.div(
  ({ theme }) => css`
    color: ${theme.co.secondary20};
    margin-top: ${theme.sz.s8};

    @media (max-width: 1152px) {
      display: none;
    }
  `,
);

export const LeftSideContainer = styled.div(
  () => css`
    width: 60%;
  `,
);

export const RightSideContainer = styled.div(() => css``);

export const LeftSideSubTitle = styled.div(
  ({ theme }) => css`
    position: relative;
    color: ${theme.co.primary20};
    padding-top: ${theme.sz.s4};
    font-size: ${theme.DEPRECATED_ty.large};
    font-weight: ${theme.DEPRECATED_ty.bold};
  `,
);

export const LeftSideTitle = styled.div(
  ({ theme }) => css`
    text-align: left;
    font-family: ${theme.DEPRECATED_ty.boing};
    color: ${theme.co.primary99};
    padding-top: ${theme.sz.s4};
    font-size: ${theme.sz.s8};
    font-weight: ${theme.DEPRECATED_ty.bold};
  `,
);

export const LeftSideDescription = styled.div(
  ({ theme }) => css`
    text-align: left;
    color: ${theme.co.primary99};
    padding-top: ${theme.sz.s4};
    font-size: ${theme.DEPRECATED_ty.medium};
  `,
);

export const BottomContainer = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    gap: ${theme.sz.s6};
  `,
);

export const AllRightReserved = styled.div(
  ({ theme }) => css`
    font-size: ${theme.DEPRECATED_ty.smaller};
    line-height: ${theme.DEPRECATED_ty.smaller};
    text-align: center;
    color: ${theme.co.secondary70};
    margin-top: ${theme.sz.s8};
  `,
);

export const MissionCard = styled(_MissionCard)(
  ({ theme }) => css`
    width: 593px;
    max-width: 593px;
    padding: ${theme.sz.s6};
    margin-left: auto;

    img {
      width: 100%;
      object-fit: cover;
    }
  `,
);
